import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import axios from "axios";

import { Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Checkbox from "@material-ui/core/Checkbox";
import SimpleBar from "simplebar-react";
import Select from "react-select";
import customStyles from "../../../../assets/select/customStyles";

const CreateEditUserDepartment = ({translation, entryId, entryChanged}) => {
    const link = localStorage.getItem('link') + '/api/UserDepartments';
    const [loaderShow, setLoaderShow] = useState(false);

    const [entry, setEntry] = useState({});
    const [failShow, setFailShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const newEntry = !(entryId > 0);

    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
    useEffect(() => {
        loadData();
    }, [entryId]);

    const loadData = () => {
        if (entryId > 0) {
            setLoaderShow(true);

            axios.get(link + '/byid?id=' + entryId, {}).then((response) => {
                console.debug(response.data);

                setEntry(response.data);

                setLoaderShow(false);
            })
                .catch((error) => {
                    console.error("Error while loading Data", error);
                    setLoaderShow(false);
                });
        }
    }

    function handleValidSubmit() {
        setFailShow(false);
        console.debug(entry);
       
        axios
        ({
            method: newEntry ? 'post' : 'put',
            url: link,
            data: entry,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                entryChanged();
            })
            .catch((error) => {
                console.error(error);
                setErrorMessage(error.message);
                setFailShow(true);
            });
    }

    return (
        <SimpleBar style={{width: "100%", height: "100%"}}>
            <div style={{width: "30%", margin: "auto"}}>
                <div style={{ marginTop: "20px" }}>
                    <h3>
                        {newEntry ? translation("administration.userDepartments.create") : translation("administration.userDepartments.edit")}
                    </h3>
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={() => {
                            handleValidSubmit();
                        }}
                    >
                        <div className="form-group">
                            <AvField
                                style={{ height: "25px" }} className="form-control"
                                name="name"
                                label={translation("administration.userDepartments.name") + ":"}
                                value={entry?.name ?? ''}
                                onChange={(e) => {
                                    entry.name = e.target.value;
                                    setEntry(entry);
                                }}
                            />
                        </div>

                        {failShow === true && (
                            <div
                                className="login-fail"
                                style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    fontSize: "100%",
                                }}
                            >
                                {errorMessage}
                            </div>
                        )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                                marginBottom: "20px",
                            }}
                        >
                            <button
                                type="submit"
                                className="button"
                                style={{ width: "100px" }}
                                onClick={() => entryChanged()}
                            >
                                {translation("allgemein.abbruch")}
                            </button>
                            <button
                                type="submit"
                                className="button"
                                style={{ marginLeft: "10px", width: "100px" }}
                            >
                                {translation("allgemein.speichern")}
                            </button>
                        </div>
                    </AvForm>
                </div>
            </div>
        </SimpleBar>
    );

};

export default withNamespaces()(CreateEditUserDepartment);
